/**
 * © 2025 Little Shilling, Inc.
 * Shon Little
 * Created: 2025-07-18
 */

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  WaitlistFormData,
  WaitlistJoinResponse,
  WaitlistVerificationResponse,
  WaitlistPositionResponse,
  WaitlistResendResponse,
} from '../../types/waitlist';
import { API_FULL_BASE_URL } from '../../config/api';

const baseUrl = API_FULL_BASE_URL;

export const waitlistApi = createApi({
  reducerPath: 'waitlistApi',
  baseQuery: fetchBaseQuery({ baseUrl }),
  tagTypes: ['Waitlist'],
  endpoints: builder => ({
    // Join the waitlist
    joinWaitlist: builder.mutation<WaitlistJoinResponse, WaitlistFormData>({
      query: data => ({
        url: 'waitlist/join/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Waitlist'],
    }),

    // Verify email address
    verifyEmail: builder.query<WaitlistVerificationResponse, string>({
      query: token => `waitlist/verify/${token}/`,
      providesTags: ['Waitlist'],
    }),

    // Check waitlist position
    checkPosition: builder.query<WaitlistPositionResponse, string>({
      query: email => ({
        url: 'waitlist/position/',
        params: { email },
      }),
      providesTags: ['Waitlist'],
    }),

    // Resend verification email
    resendVerification: builder.mutation<
      WaitlistResendResponse,
      { email: string }
    >({
      query: data => ({
        url: 'waitlist/resend-verification/',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useJoinWaitlistMutation,
  useVerifyEmailQuery,
  useCheckPositionQuery,
  useResendVerificationMutation,
} = waitlistApi;
